import { InfoItemButton as L2rInfoItemButton, Typography, Skeleton as UiSkeleton, styled } from "@l2r-front/l2r-ui"

export const InfoItemButton = styled(L2rInfoItemButton)({
    height: 46,
})

export const Skeleton = styled(UiSkeleton)({
    width: 50,
    height: "100%",
    transform: "scale(1)",
})

export const Error = styled(Typography)(({ theme }) => ({
    color: theme.palette["error/main"].main,
}))